import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from "@mui/material";
import PropTypes from "prop-types";
import { getAPIEndpoint, handleAPICall } from "../helper.js";
import { formControlDefaults } from "../formControlDefaults.js";

Select.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
  apiGet: PropTypes.func,
};

export default function Select(props) {
  const {
    item,
    value = "",
    values,
    error = null,
    onChange,
    showErrorText = false,
    apiGet = null,
    disabled = false,
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState(item.options || null);
  const [lastAPIEndpoint, setLastAPIEndpoint] = useState("");

  useEffect(() => {
    const get_api =
      typeof item.get_api === "function" ? item.get_api(values) : item.get_api;

    if (
      values &&
      item.get_api &&
      lastAPIEndpoint !== getAPIEndpoint(get_api, values)
    )
      setLastAPIEndpoint(
        handleAPICall(
          get_api,
          values,
          apiGet,
          (data) => {
            if (get_api.setResult) {
              setOptions(get_api.setResult(data));
            } else {
              setOptions(data);
            }
          },
          setIsLoading,
          get_api.params
        )
      );
    else setIsLoading(false);
  }, [item.get_api, apiGet]);

  let helperText = "";
  if (showErrorText) helperText = error;

  if (isLoading) return <></>;
  else
    return (
      <FormControl
        {...formControlDefaults}
        {...(error && { error: true })}
        sx={{ width: "100%" }}
      >
        <InputLabel>{item.label}</InputLabel>
        {options && (
          <MuiSelect
            name={item.name}
            value={value}
            label={item.label}
            disabled={disabled}
            onChange={onChange}
          >
            {options.map((sitem) => (
              <MenuItem key={sitem.key} value={sitem.key}>
                {sitem.label}
              </MenuItem>
            ))}
          </MuiSelect>
        )}
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    );
}
